export default __webpack_public_path__ + "static/media/35850.f3434855.jpg";